module.exports = __webpack_public_path__ + "media/images/lb/790-b1d87a6d288a4d2fffa8db50709ceb71.svg";